import {FormInstance, Space} from "antd";
import React, {ComponentProps, useEffect, useState} from "react";
import {useRequest} from "ahooks";
import * as api from "../../../apis/salesOrder"
import dayjs from "dayjs";
import {Decimal} from "decimal.js";

type PaymentTabProps = ComponentProps<any> & {
    record: any
}

function PaymentTab(props: PaymentTabProps) {

    const record = props.record
    const [orderAmount, setOrderAmount] = useState(0)
    const [paid, setPaid] = useState(0)
    const [writeOffItem, setWriteOffItem] = useState<Array<any>>([])

    useEffect(() => {
        if (record) {
            setOrderAmount(record.productTotalAmount + record.shippingCost)
            setPaid(record.paid)
            run(record.id)
        }
    }, [record])

    const {loading, run} = useRequest(api.getOrderWriteOff, {
        manual: true,
        onSuccess: (res) => {
            setWriteOffItem(res.data.data)
        }
    })

    return (
        <div>
            <Space>
                <h4>订单合计：<h2 style={{display: "inline", color: "red"}}>{orderAmount}</h2></h4>
                <h4>已付款：<h2 style={{display: "inline", color: "red"}}>{paid}</h2></h4>
                <h4>未付款：<h2 style={{display: "inline", color: "red"}}>{Decimal.sub(orderAmount,paid).toString()}</h2></h4>
            </Space>
            <table
                style={{
                    width: '100%',
                    textAlign: "center",
                    borderCollapse: 'collapse',
                    borderColor: 'rgba(5, 5, 5, 0.06)'
                }}
                border={1}
                cellSpacing={0} cellPadding={0}>
                <thead>
                <tr style={{height: 40}}>
                    <td width={'20%'}>核销单号</td>
                    <td width={'20%'}>收款单号</td>
                    <td width={'20%'}>类型</td>
                    <td width={'20%'}>核销日期</td>
                    <td width={'20%'}>核销金额</td>
                </tr>
                </thead>
                <tbody>
                {writeOffItem.length > 0 ? writeOffItem.map((item: any) => (
                        <tr style={{height: 40}}>
                            <td>{item.writeOffNo}</td>
                            <td>{item.receiptNo}</td>
                            <td>{item.type === 0 ? '手动' : '自动'}</td>
                            <td>{dayjs(item.writeOffDate).format('ll')}</td>
                            <td>{item.writeOffAmount}</td>
                        </tr>
                    )) :
                    <tr>
                        <td colSpan={5} style={{textAlign: "center", height: 40}}>
                            暂无核销数据
                        </td>
                    </tr>
                }
                </tbody>
            </table>
        </div>
    )
}

export default PaymentTab;